export default __webpack_public_path__ + "assets/images/88bcb5ec20bbd043a6ad77f2c4fe0a74.png";